import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=f3cdeda4&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style1 from "./Index.vue?vue&type=style&index=1&id=f3cdeda4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3cdeda4",
  null
  
)

export default component.exports